import ProjectListItem from '@/components/ProjectStep/ProjectListItem';
import { ProjectType } from '@/types/project';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useMemo } from 'react';

type Props = {
  project: ProjectType;
  setOpenDeleteModal: () => void;
  setOpenArchiveModal: () => void;
  setOpenEditModal: () => void;
  setOnClickExportButton: () => void;
  isDragging?: boolean;
};

function SortableProjectListItem({
  project,
  setOpenArchiveModal,
  setOpenDeleteModal,
  setOpenEditModal,
  setOnClickExportButton,
  isDragging = false,
}: Props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({ id: project.id });

  const style = useMemo(
    () => ({
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging || isSortableDragging ? 0.5 : 1,
      cursor: isDragging ? 'grabbing' : 'grab',
    }),
    [transform, transition, isDragging, isSortableDragging],
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <ProjectListItem
        project={project}
        setOpenArchiveModal={setOpenArchiveModal}
        setOpenDeleteModal={setOpenDeleteModal}
        setOpenEditModal={setOpenEditModal}
        setOnClickExportButton={setOnClickExportButton}
      />
    </div>
  );
}

export default SortableProjectListItem;
